import './index.css'


export default function OMRAbout() {
	if (window.oᐧextra.flagꓽdebug_render) console.log('🔄 OMRAbout')

	return (
		<div>
			<p>
				A hobby game from <a href="https://github.com/Offirmo" target="_blank" rel="noopener noreferrer">Offirmo</a>
			</p>
			<p>A remake
				of the original, now defunct, browser game <a href="https://www.reddit.com/r/boringrpg/" target="_blank" rel="noopener noreferrer">The boring RPG</a>
			{' '}by <a href="https://www.reddit.com/user/andypants" target="_blank" rel="noopener noreferrer">andypants</a>.
			</p>
			<p>
				See <a href="https://www.online-adventur.es/" target="_blank" rel="noopener noreferrer">all my games</a>
			</p>
		</div>
	)
}
